export default __webpack_public_path__ + "static/media/arras06.dda54c48.jpg";